import ButtonPrimary from "shared/Button/ButtonPrimary";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import NcImage from "shared/NcImage/NcImage";
import failImage from "images/fail.png";
import { useHistory } from "react-router-dom";

const PaymentFailed: React.FC = () => (

  <div className="nc-Page404">
    <Helmet>
      <title>Payment Failed || DoDo Shop</title>
    </Helmet>
    <div className="container relative pt-5 pb-16 lg:pb-20 lg:pt-5">
      {/* HEADER */}
      <header className="text-center max-w-2xl mx-auto space-y-2">
        <NcImage src={failImage} />
        <span className="block text-sm text-neutral-800 sm:text-base dark:text-neutral-200 tracking-wider font-medium">
          PAYMENT FAILED.{" Something when wrong"}
        </span>
        <div className="pt-8">
          <ButtonPrimary href="/checkout">Go back to Checkout Page</ButtonPrimary>
        </div>
      </header>
    </div>
  </div>
);

export default PaymentFailed;
